import type { FetchLike, WretchOptions } from 'wretch';
import { getSid } from '@/services/sid';

const sidMiddleware = (next: FetchLike) => async (url: string, opts: WretchOptions) => {
  const sid = await getSid();

  opts.headers = {
    ...opts.headers,
    'x-client-id': sid,
  };

  return next(url, opts);
};

export default sidMiddleware;
